import { z } from 'zod';
export const syncReviewLevels = [
    'metadata_only',
    'deterministic_hygiene',
    'semantic_delta',
    'targeted_llm_review',
    'full_architectural_review',
];
export const syncRiskDomains = [
    'runtime',
    'orchestration',
    'auth',
    'security',
    'database',
    'api_contracts',
    'billing',
    'deployment',
    'frontend',
    'documentation',
    'tests',
    'dependencies',
];
export const syncReviewLevelSchema = z.enum(syncReviewLevels);
export const syncRiskDomainSchema = z.enum(syncRiskDomains);
export const syncReviewPolicyInputSchema = z.object({
    changedFiles: z.array(z.string()).default([]),
    changedLineCount: z.number().int().min(0).default(0),
    priorCriticalFindings: z.number().int().min(0).default(0),
    priorHighFindings: z.number().int().min(0).default(0),
    userRequestedAudit: z.boolean().default(false),
    forceFullReview: z.boolean().default(false),
    daysSinceLastFullReview: z.number().min(0).nullable().optional(),
});
export const syncReviewPolicyDecisionSchema = z.object({
    level: syncReviewLevelSchema,
    domains: z.array(syncRiskDomainSchema),
    reasons: z.array(z.string()),
    shouldRunDeterministicChecks: z.boolean(),
    shouldRunSemanticDelta: z.boolean(),
    shouldRunTargetedLlmReview: z.boolean(),
    shouldRunFullArchitecturalReview: z.boolean(),
});
export function parseSyncReviewPolicyInput(input) {
    return syncReviewPolicyInputSchema.parse(input);
}
export function parseSyncReviewPolicyDecision(input) {
    return syncReviewPolicyDecisionSchema.parse(input);
}
//# sourceMappingURL=sync-review-policy.js.map